import { render, staticRenderFns } from "./PriorityZoneCopy.vue?vue&type=template&id=58a9f3ce&"
import script from "./PriorityZoneCopy.vue?vue&type=script&lang=js&"
export * from "./PriorityZoneCopy.vue?vue&type=script&lang=js&"
import style0 from "./PriorityZoneCopy.vue?vue&type=style&index=0&id=58a9f3ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports